<template>
  <CommonDialog v-model:is-active="modalActive">
    <template #header>Knockaut Projekt Details</template>
    <template #content>
      <pre class="text-pre-wrap border pa-2">{{ props.knockautProject }}</pre>
    </template>
    <template #actions>
      <v-btn variant="flat" color="success" @click="save()">Speichern</v-btn>
      <v-btn variant="text" @click="cancel()">Abbrechen</v-btn></template
    >
  </CommonDialog>
</template>

<script setup lang="ts">
import { KnockautProject } from '@/apps/brelag/common/models/knockaut'
import CommonDialog from '@/components/common/CommonDialog.vue'

type KnockautDetailModalProps = {
  knockautProject: KnockautProject | null
}

const emit = defineEmits(['cancel'])
const modalActive = defineModel<boolean>('isActive')
const props = defineProps<KnockautDetailModalProps>()

function save() {
  cancel()
}

function cancel() {
  emit('cancel')
}
</script>

<style lang="scss" scoped></style>
